import { RootState } from 'data/root.reducers';
import { DeliveryFunctionNetworkInterface } from './deliveryFunctionNetworkInterface.types';

export const getDeliveryFunctionNetworkInterfaceList = (state: RootState): DeliveryFunctionNetworkInterface[] =>
  state.deliveryFunctionNetworkInterface.entities;

export const getDeliveryFunctionNetworkInterface = (state: RootState): DeliveryFunctionNetworkInterface | null =>
  state.deliveryFunctionNetworkInterface.single;
export const getSelectedDeliveryFunctionNetworkInterface = (state: RootState): DeliveryFunctionNetworkInterface[] =>
  state.deliveryFunctionNetworkInterface.selected;
export const getDeliveryFunctionNetworkInterfaceCreatedId = (state: RootState): string | null =>
  state.deliveryFunctionNetworkInterface.createdId;

export const isDeliveryFunctionNetworkInterfaceCreatePopupOpen = (state: RootState): boolean =>
  state.deliveryFunctionNetworkInterface.ui.isCreatePopupOpen;
export const isDeliveryFunctionNetworkInterfaceEditPopupOpen = (state: RootState): boolean =>
  state.deliveryFunctionNetworkInterface.ui.isEditPopupOpen;
export const isDeliveryFunctionNetworkInterfaceLoading = (state: RootState): boolean =>
  state.deliveryFunctionNetworkInterface.ui.isLoading;
